/**
 * BeezFy Cart Fix Script
 * Patches and improves the premium cart system
 */

(function() {
  console.warn('🔧 BeezFy Cart Fix: Initializing fixes...');

  // Wait for DOM ready
  function domReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  domReady(function() {
    console.warn('🔧 BeezFy Cart Fix: DOM ready, applying fixes...');

    // Fix 1: Ensure cart drawer exists and is properly styled
    function ensureCartDrawer() {
      let drawer = document.querySelector('#beezfy-cart-drawer');

      if (drawer) {
        // Ensure drawer is visible (remove display: none if present)
        if (drawer.style.display === 'none') {
          drawer.style.display = '';
          console.warn('🔧 Fixed: Removed display:none from cart drawer');
        }

        // Add active class handler
        const cartIcon = document.querySelector('.header__icon--cart, [data-action="open-cart"]');
        if (cartIcon) {
          cartIcon.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            // Open cart using premium cart system if available
            if (window.BeezfyCart && window.BeezfyCart.open) {
              console.warn('🔧 Opening cart via BeezfyCart.open()');
              window.BeezfyCart.open();
            } else {
              // Fallback: manually add active class
              console.warn('🔧 Opening cart via manual class toggle');
              drawer.classList.add('active', 'is-open');
              document.body.classList.add('drawer-open');

              // Create/show overlay
              let overlay = document.querySelector('.beezfy-drawer-overlay');
              if (!overlay) {
                overlay = document.createElement('div');
                overlay.className = 'beezfy-drawer-overlay';
                document.body.appendChild(overlay);
              }
              overlay.classList.add('active', 'is-active');
            }
          });
          console.warn('🔧 Fixed: Added cart icon click handler');
        }

        // Fix close button
        const closeBtn = drawer.querySelector('[data-drawer-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function(e) {
            e.preventDefault();

            if (window.BeezfyCart && window.BeezfyCart.close) {
              window.BeezfyCart.close();
            } else {
              drawer.classList.remove('active', 'is-open');
              document.body.classList.remove('drawer-open');
              const overlay = document.querySelector('.beezfy-drawer-overlay');
              if (overlay) {
                overlay.classList.remove('active', 'is-active');
              }
            }
          });
          console.warn('🔧 Fixed: Added close button handler');
        }
      } else {
        console.error('🔧 Cart drawer not found!');
      }
    }

    // Fix 2: Ensure BeezfyCart is initialized
    function ensureCartSystem() {
      if (!window.BeezfyCart) {
        console.warn('🔧 BeezfyCart not found, checking for initialization...');

        // Check if the script is loaded
        const scripts = Array.from(document.scripts);
        const hasPremiumCart = scripts.some(s => s.src.includes('beezfy-cart-premium'));

        if (!hasPremiumCart) {
          console.warn('🔧 Loading beezfy-cart-premium.js...');
          const script = document.createElement('script');
          script.src = '/assets/beezfy-cart-premium.js';
          script.onload = function() {
            console.warn('🔧 Premium cart script loaded');
            setTimeout(ensureCartSystem, 500);
          };
          document.head.appendChild(script);
        } else {
          // Script is loaded but BeezfyCart is not initialized
          // Try to initialize it manually
          setTimeout(function() {
            if (!window.BeezfyCart && window.BeezfyPremiumCart) {
              window.BeezfyCart = new window.BeezfyPremiumCart();
              console.warn('🔧 Manually initialized BeezfyCart');
            }
          }, 1000);
        }
      } else {
        console.warn('✅ BeezfyCart is initialized');

        // Ensure cart is fetched
        if (window.BeezfyCart.refresh) {
          window.BeezfyCart.refresh();
        }
      }
    }

    // Fix 3: Update cart counts
    function updateCartCounts() {
      if (window.BeezfyCart && window.BeezfyCart.getCart) {
        const cart = window.BeezfyCart.getCart();
        if (cart) {
          const counts = document.querySelectorAll('[data-cart-count], .cart-count');
          counts.forEach(el => {
            el.textContent = cart.item_count || 0;
            if (cart.item_count > 0) {
              el.style.display = '';
            }
          });
          console.warn('🔧 Updated cart counts:', cart.item_count);
        }
      }
    }

    // Fix 4: Listen for cart events
    function setupEventListeners() {
      const events = ['cart:add', 'cart:update', 'product:added', 'beezfy:cart:updated'];

      events.forEach(eventName => {
        document.addEventListener(eventName, function() {
          console.warn('🔧 Cart event detected:', eventName);
          updateCartCounts();

          // Refresh cart if available
          if (window.BeezfyCart && window.BeezfyCart.refresh) {
            window.BeezfyCart.refresh();
          }
        });
      });

      console.warn('🔧 Event listeners attached');
    }

    // Apply all fixes
    ensureCartDrawer();
    ensureCartSystem();
    setupEventListeners();

    // Update counts after a delay
    setTimeout(updateCartCounts, 1000);

    // Provide global helper function
    window.testCart = function() {
      console.group('🛒 Cart System Test');

      console.log('BeezfyCart exists:', !!window.BeezfyCart);
      console.log('Cart drawer exists:', !!document.querySelector('#beezfy-cart-drawer'));
      console.log('Cart icon exists:', !!document.querySelector('.header__icon--cart'));
      console.log('Overlay exists:', !!document.querySelector('.beezfy-drawer-overlay'));

      if (window.BeezfyCart) {
        const cart = window.BeezfyCart.getCart();
        console.log('Cart state:', cart);
        console.log('Is open:', window.BeezfyCart.isCartOpen ? window.BeezfyCart.isCartOpen() : 'N/A');
      }

      console.groupEnd();
    };

    console.warn('✅ BeezFy Cart Fix: All fixes applied');
    console.warn('💡 Run window.testCart() to check cart status');
  });
})();